import LuAgency from './LuAgency'
import LuAgencyRole from './LuAgencyRole'
import User from './User'
export default class UserAgency {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      //UserID is required
      UserID: 0,
      //AgencyID is required
      AgencyID: 0,
      //AgencyRoleID is required
      AgencyRoleID: 0,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.UserID = obj.UserID
    this.AgencyID = obj.AgencyID
    this.AgencyRoleID = obj.AgencyRoleID
    this.Agency = new LuAgency(obj.Agency || {})
    this.AgencyRole = new LuAgencyRole(obj.AgencyRole || {})
    this.User = new User(obj.User || {})
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.Agency = null
    obj.AgencyRole = null
    obj.User = null
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.Agency = null
    obj.AgencyRole = null
    obj.User = null
    return obj
  }
}
